<style src="./SideMenu.scss" lang="scss"></style>
<template>
  <div class="side-menu">
    <nav
      class="navbar-default navbar-static-side"
      role="navigation"
      :class="{ collapsed: collapsed, 'animated fadeInLeft': isMobile() }"
    >
      <div class="sidebar-collapse">
        <ul class="nav">
          <li class="nav-header">
            <div class="dropdown profile-element">
              <img alt="image" class="img-circle" :src="user.img" />
              <div class="dropdown-toggle">
                <div class="clear">
                  <span class="block m-t-xs">
                    <strong class="username">{{ fullName }} </strong>
                  </span>
                  <br />
                  <span class="client" v-if="!canChangeClient">
                    {{ client.fullName }}
                  </span>
                  <span
                    @click="changeClient"
                    class="client changeclient"
                    v-if="canChangeClient"
                  >
                    {{ client.fullName }}
                  </span>
                  <br />
                  <br />
                </div>
              </div>
            </div>

            <button
              @click.prevent="closeIfMobile()"
              class="btn btn-link visible-xs-block"
            >
              <i class="fa fa-close" />
            </button>
          </li>

          <span
            v-if="hasNewMessages"
            class="new-messages label label-warning"
            @click="navigateToMessages"
          >
            <i class="fa fa-comments" />
          </span>
          <li
            class="nav-menu"
            v-for="(menu, menuKey) in menuOptions"
            v-bind:key="menuKey"
          >
            <a
              href="#"
              v-if="
                !menu.path &&
                  $store.getters['DATA-ACCESS/HasAccess'](menu.sectorId, 'SHOW')
              "
              @click.prevent="collapseMenu(menuKey)"
            >
              <i :class="menu.icon"></i>
              <span class="nav-label">{{ menu.name }}</span>
              <span
                v-show="menu.submenu"
                class="fa arrow menu-arrow"
                :class="{ 'menu-arrow-down': !menu.collapsed }"
              ></span>
            </a>

            <router-link
              v-if="
                menu.path &&
                  $store.getters['DATA-ACCESS/HasAccess'](menu.sectorId, 'SHOW')
              "
              :to="menu.path"
              @click="closeIfMobile()"
              data-toggle="tooltip"
              v-bind:title="menu.name"
            >
              <i :class="menu.icon"></i>
              <span class="nav-label">{{ menu.name }}</span>
            </router-link>
            <ul class="nav nav-second-level" v-show="!menu.collapsed">
              <li
                v-for="(submenuItem, submenuKey) in menu.submenu"
                :key="submenuKey"
              >
                <router-link
                  v-if="
                    $store.getters['DATA-ACCESS/HasAccess'](
                      submenuItem.sectorId,
                      'SHOW',
                    )
                  "
                  :to="submenuItem.path"
                >
                  {{ submenuItem.name }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="logoff" @click="logoff">
        <i class="fa fa-door-open"></i>
        Sair
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from '@/plugins/toast';

export default {
  data() {
    return {
      expires: new Date(),
      user: {
        name: 'user name',
        role: 'Manager',
        img: '/static/images/profile.jpg',
      },
      menuOptions: [
        {
          name: 'Dashboard',
          icon: 'fa fa-home',
          path: null,
          collapsed: true,
          sectorId: 'dashboard',
          submenu: [
            {
              sectorId: 'dashboard-revenue',
              name: 'Receita',
              icon: 'fa fa-home',
              path: '/dashboard',
            },
            {
              sectorId: 'dashboard-parking',
              name: 'Estacionamentos',
              icon: 'fa fa-home',
              path: '/dashboard-parking',
            },
          ],
        },
        {
          name: 'Relatórios',
          icon: 'fa fa-home',
          path: null,
          collapsed: true,
          sectorId: 'report',
          submenu: [
            {
              sectorId: 'report-settled-credits',
              name: 'Relatório de Créditos Quitados',
              icon: 'fa fa-handshake',
              path: '/reports/settled-credits',
            },
            {
              sectorId: 'report-daily-sales-monitor',
              name: 'Resumo Diário de Vendas por Monitor',
              icon: 'fa fa-handshake',
              path: '/reports/employee-daily-resume-credit',
            },
            {
              sectorId: 'report-monthly-sales-monitor',
              name: 'Resumo Mensal de Vendas por Monitor',
              icon: 'fa fa-handshake',
              path: '/reports/employee-monthly-resume-credit',
            },
            {
              sectorId: 'report-daily-sales-global',
              name: 'Resumo Diário de Vendas Global',
              icon: 'fa fa-handshake',
              path: '/reports/global-daily-resume-credit',
            },
            {
              sectorId: 'report-monthly-sales-global',
              name: 'Resumo Mensal de Vendas Global',
              icon: 'fa fa-handshake',
              path: '/reports/global-monthly-resume-credit',
            },

            {
              sectorId: 'report-notify',
              name: 'Veículos Negativados',
              icon: 'fa fa-handshake',
              path: '/report-notify',
            },
            {
              sectorId: 'report-computed-credit',
              name: 'Faturamento',
              icon: 'fa fa-handshake',
              path: '/report-billing',
            },
            {
              sectorId: 'report-credit',
              name: 'Credito Pago',
              icon: 'fa fa-handshake',
              path: '/report-credit',
            },
            {
              sectorId: 'report-credit',
              name: 'Credito por Monitor',
              icon: 'fa fa-handshake',
              path: '/report-synthetic-credit',
            },
            {
              sectorId: 'report-credit',
              name: 'Veículo Devedor',
              icon: 'fa fa-handshake',
              path: '/report-opened-debits',
            },
            {
              sectorId: 'report-parked-notified',
              name: 'Veículos Estacionandos Negativos',
              icon: 'fa fa-handshake',
              path: '/report-parked-notified',
            },
            {
              sectorId: 'report-occupation-rate',
              name: 'Relatório de Taxa de Ocupação',
              icon: 'fa fa-handshake',
              path: '/occupation-rate',
            },
            {
              sectorId: 'report-occupation-rate',
              name: 'Relatório de Notificações por Monitor',
              icon: 'fa fa-handshake',
              path: '/reports/employee-notification-report',
            },
            {
              sectorId: 'report-parking-meter',
              name: 'Parquímetro',
              icon: 'fa fa-handshake',
              path: '/reports/parking-meter',
            },
            {
              sectorId: 'report-employee-performance',
              name: 'Relatório de Performance por Monitor',
              icon: 'fa fa-handshake',
              path: '/reports/employee-performance',
            },
            {
              sectorId: 'report-employee-list',
              name: 'Relatório de Vendas do Monitor',
              icon: 'fa fa-handshake',
              path: '/reports/report-employee-list',
            },
            {
              sectorId: 'report-daily-sales-pdv',
              name: 'Relatório Analítico Diário do PDV',
              icon: 'fa fa-handshake',
              path: '/analytic/daily/pdv',
            },
            {
              sectorId: 'report-monthly-sales-pdv',
              name: 'Relatório Analítico Mensal do PDV',
              icon: 'fa fa-handshake',
              path: '/analytic/monthly/pdv',
            },

            {
              sectorId: 'report-daily-sales-cabine',
              name: 'Relatório Analítico Diário da Cabine',
              icon: 'fa fa-handshake',
              path: '/analytic/daily/cabine',
            },
            {
              sectorId: 'report-monthly-sales-cabine',
              name: 'Relatório Analítico Mensal do Cabine',
              icon: 'fa fa-handshake',
              path: '/analytic/monthly/cabine',
            },

            {
              sectorId: 'report-daily-sales-parking-meter',
              name: 'Relatório Analítico Diário do Parquímetro',
              icon: 'fa fa-handshake',
              path: '/analytic/daily/parkingmeter',
            },
            {
              sectorId: 'report-monthly-sales-parking-meter',
              name: 'Relatório Analítico Mensal do Parquímetro',
              icon: 'fa fa-handshake',
              path: '/analytic/monthly/parkingmeter',
            },

            {
              sectorId: 'report-daily-sales-agent',
              name: 'Relatório Analítico Diário do Agente',
              icon: 'fa fa-handshake',
              path: '/analytic/daily/agent',
            },
            {
              sectorId: 'report-monthly-sales-agent',
              name: 'Relatório Analítico Mensal do Agente',
              icon: 'fa fa-handshake',
              path: '/analytic/monthly/agent',
            },
          ],
        },
        {
          name: 'OCR',
          icon: 'fa fa-camera',
          path: null,
          collapsed: true,
          sectorId: 'ocr',
          submenu: [
            {
              sectorId: 'ocr-reports',
              name: 'Relatório',
              icon: 'fa fa-report',
              path: '/ocr/report',
            },
          ],
        },
        {
          name: 'Cadastros',
          icon: 'fa fa-edit',
          path: null,
          collapsed: true,
          sectorId: 'register',
          submenu: [
            {
              sectorId: 'retroactive-credit',
              name: 'Registro Retroativo',
              icon: 'fa fa-vote-yea',
              path: '/outdated-register',
            },
            {
              sectorId: 'bulk-retroactive-credit',
              name: 'Registro Retroativo em Lote',
              icon: 'fa fa-vote-yea',
              path: '/bulk-outdated-register',
            },
            {
              sectorId: 'register-employee',
              name: 'Usuário',
              icon: 'fa fa-user',
              path: '/register-employee',
            },
            {
              sectorId: 'create-zone',
              name: 'Zonas',
              icon: 'fa fa-user',
              path: '/create-zone',
            },
            {
              sectorId: 'register-park',
              name: 'Estacionamentos',
              icon: 'fa fa-user',
              path: '/register-park',
            },
            {
              sectorId: 'point-of-interest',
              name: 'Pontos de Interesse',
              icon: 'fa fa-user',
              path: '/register-point-of-interest',
            },
            {
              sectorId: 'vehicles',
              name: 'Veículos',
              icon: 'fa fa-user',
              path: '/vehicles',
            },
          ],
        },
        {
          name: 'Painel de Controle',
          icon: 'fa fa-home',
          path: null,
          collapsed: true,
          sectorId: 'control-panel',
          submenu: [
            {
              sectorId: 'roles',
              name: 'Permissões',
              icon: 'fa fa-handshake',
              path: '/roles',
            },
            {
              sectorId: 'roles',
              name: 'Gerenciamento de Permissões',
              icon: 'fa fa-handshake',
              path: '/roles-management',
            },
          ],
        },
        {
          name: 'Veículo',
          icon: 'fa fa-car',
          path: null,
          collapsed: true,
          sectorId: 'vehicle',
          submenu: [
            {
              sectorId: 'vehicle-history',
              name: 'Histórico',
              icon: 'fa fa-handshake',
              path: '/vehicle-history',
            },
          ],
        },
        {
          name: 'Atendimento',
          icon: 'fa fa-comments',
          path: null,
          collapsed: true,
          sectorId: 'attendance',
          submenu: [
            {
              sectorId: 'consumer-message',
              name: 'Monitor',
              icon: 'fa fa-comment',
              path: '/monitor-message',
            },
            {
              sectorId: 'monitor-message',
              name: 'Cliente',
              icon: 'far fa-comment-dots',
              path: '/consumer-message',
            },
            {
              sectorId: 'consumer-list',
              name: 'Lista de Clientes',
              icon: 'far fa-comment-dots',
              path: '/consumer/list',
            },
            {
              sectorId: 'allow-payment',
              name: 'Liberar Pagamento',
              icon: 'far fa-comment-dots',
              path: '/allow-payment',
            },
            {
              sectorId: 'allow-payment',
              name: 'Reativar Pagamento',
              icon: 'far fa-comment-dots',
              path: '/reactive-payment',
            },
          ],
        },
        {
          name: 'Campanha',
          icon: 'fa fa-bullhorn',
          path: null,
          collapsed: true,
          sectorId: 'campaign',
          submenu: [
            {
              sectorId: 'create-campaign',
              name: 'Criar campanha',
              icon: 'fa fa-bullhorn',
              path: '/create-campaign',
            },
          ],
        },
        {
          name: 'Mapas',
          icon: 'fa fa-map-marker',
          path: null,
          collapsed: true,
          sectorId: 'maps',
          submenu: [
            {
              sectorId: 'parking-map',
              name: 'Estacionamentos',
              icon: 'fa fa-map-marker',
              path: '/parking-map',
            },
            {
              sectorId: 'usage-density',
              name: 'Densidade de vagas ocupadas',
              icon: 'fa fa-map-marker',
              path: '/usage-density',
            },
            {
              sectorId: 'employee-map',
              name: 'Monitores',
              icon: 'fa fa-map-marker',
              path: '/employee-map',
            },
          ],
        },
        {
          name: 'Carteira',
          icon: 'fa fa-tags',
          path: null,
          collapsed: true,
          sectorId: 'wallet',
          submenu: [
            {
              sectorId: 'wallet-bonus',
              name: 'Bonus em Carteira',
              icon: 'fa fa-tag',
              path: '/wallet-bonus',
            },
            {
              sectorId: 'wallet-reversal',
              name: 'Estorno de crédito',
              icon: 'fa fa-tag',
              path: '/wallet-reversal',
            },
            {
              sectorId: 'vehicle-reversal',
              name: 'Estorno do veículo',
              icon: 'fa fa-tag',
              path: '/reversal',
            },
          ],
        },
        {
          name: 'Configurações',
          icon: 'fa fa-cog',
          path: null,
          collapsed: true,
          sectorId: 'config',
          submenu: [
            {
              sectorId: 'roles',
              name: 'Impressão de Ticket',
              icon: 'fa fa-cog',
              path: '/print-config',
            },
            {
              sectorId: 'assign-client-to-user',
              name: 'Associar User ao Cliente',
              icon: 'fa fa-cog',
              path: '/assign-user-client',
            },
            {
              sectorId: 'add-client',
              name: 'Clientes',
              icon: 'fa fa-cog',
              path: '/clients',
            },
            {
              sectorId: 'relate-show-schedule-spots',
              name: 'Relacionar agenda para listagem de vagas',
              icon: 'fa fa-cog',
              path: '/relate-show-schedule-spots',
            },
          ],
        },
        {
          name: 'Serviço Tarifário',
          icon: 'fa fa-cog',
          path: null,
          collapsed: true,
          sectorId: 'tariff-service',
          submenu: [
            {
              sectorId: 'tariff-plan',
              name: 'Plano Tarifário',
              icon: 'fa fa-cog',
              path: '/tariff-plan',
            },
            {
              sectorId: 'tariff-schedule',
              name: 'Agenda Tarifária',
              icon: 'fa fa-cog',
              path: '/tariff-schedule',
            },
            {
              sectorId: 'relate-tariff-schedule',
              name: 'Relacionar agenda tarifária',
              icon: 'fa fa-cog',
              path: '/relate-tariff-schedule',
            },
            {
              sectorId: 'price-ticket',
              name: 'Valores de compra de crédito',
              icon: 'fa fa-user',
              path: '/price-ticket',
            },
          ],
        },
        {
          name: 'Controle de Caixa',
          icon: 'fa fa-cash-register',
          path: null,
          collapsed: true,
          sectorId: 'accounting-cash',
          submenu: [
            {
              sectorId: 'close-accounting-cash',
              name: 'Fechamento de caixa',
              icon: 'fa fa-cog',
              path: '/close-accounting-cash',
            },
            {
              sectorId: 'manager-accounting-cash',
              name: 'Gerenciamento de caixa',
              icon: 'fa fa-cog',
              path: '/manager-accounting-cash',
            },
            {
              sectorId: 'accounting-cash-report',
              name: 'Relatório de caixa',
              icon: 'fa fa-cog',
              path: '/accounting-cash-report',
            },
          ],
        },
        {
          name: 'Controle de Contas',
          icon: 'fa fa-cash-register',
          path: null,
          collapsed: true,
          sectorId: 'financial-account',
          submenu: [
            {
              sectorId: 'register-financial-account',
              name: 'Gerenciar contas',
              icon: 'fa fa-cog',
              path: '/register-financial-account',
            },
            {
              sectorId: 'labels',
              name: 'Plano de contas',
              icon: 'fa fa-user',
              path: '/labels',
            },
            {
              sectorId: 'register-account-movements',
              name: 'Gerenciar movimentos',
              icon: 'fa fa-cog',
              path: '/register-account-movements',
            },
            {
              sectorId: 'register-creditor',
              name: 'Gerenciar Credores',
              icon: 'fa fa-cog',
              path: '/register-creditor',
            },
          ],
        },
        {
          name: 'Guarda Municipal',
          icon: 'fa fa-cash-register',
          path: null,
          collapsed: true,
          sectorId: 'guard-request',
          submenu: [
            {
              sectorId: 'guard-request-info',
              name: 'Gerenciar Requisições',
              icon: 'fa fa-cog',
              path: '/guard-request-info',
            },
            {
              sectorId: 'guard-notifications',
              name: 'Gerenciar Notificações',
              icon: 'fa fa-cog',
              path: '/guard-notifications',
            },
          ],
        },
        {
          name: 'Autuação SERPRO',
          icon: 'fa fa-cash-register',
          path: null,
          collapsed: true,
          sectorId: 'notification-serpro',
          submenu: [
            {
              sectorId: 'serpro-send-notifications',
              name: 'Enviar Autuação',
              icon: 'fa fa-cog',
              path: '/send-autuacao',
            },
            {
              sectorId: 'serpro-status',
              name: 'Acompanhar Autuação',
              icon: 'fa fa-cog',
              path: '/serpro-status',
            },
            {
              sectorId: 'serpro-config',
              name: 'Configurações',
              icon: 'fa fa-cog',
              path: '/serpro-config',
            },
          ],
        },
        {
          name: 'ATM',
          icon: 'fa fa-cash-register',
          path: null,
          collapsed: true,
          sectorId: 'dashboard',
          submenu: [
            {
              sectorId: 'dashboard',
              name: 'Mapa dos ATMs',
              icon: 'fa fa-cog',
              path: '/atm-map',
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      fullName: 'DATA-ACCESS/fullName',
      client: 'DATA-ACCESS/client',
      consumnerMessages: 'MESSAGES/consumerOpenMessages',
      hasMonitorNewMessage: 'MESSAGES/unreadMonitorMessages',
      canChangeClient: 'DATA-ACCESS/canChangeClient',
    }),
    permissionConsumerMessages() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'consumer-message',
        'SHOW',
      );
    },
    hasNewMessages() {
      return (
        this.hasMonitorNewMessage.length > 0 ||
        (this.consumnerMessages.length > 0 && this.permissionConsumerMessages)
      );
    },
    collapsed() {
      return this.$store.state.collapsed;
    },
  },

  mounted() {
    // this.$store.dispatch('MESSAGES/WatchConsumer');
    this.watchMonitor();
  },
  methods: {
    capitalize(value) {
      if (!value) {
        return;
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    closeIfMobile() {},
    isMobile() {},
    async logoff() {
      await this.$store.dispatch('DATA-ACCESS/doLogout');
      this.$router.replace('/');
    },
    collapseMenu(menuKey) {
      this.menuOptions[menuKey].collapsed = !this.menuOptions[menuKey]
        .collapsed;
    },
    watchMonitor() {
      try {
        this.$store.dispatch('MESSAGES/WatchMonitor');
      } catch (error) {
        toast.error('Não foi observar usuários');
      }
    },
    navigateToMessages() {
      if (this.hasMonitorNewMessage.length > 0) {
        this.$router.push({
          name: 'MonitorMessage',
        });
      } else {
        this.$router.push({
          name: 'ConsumerMessage',
        });
      }
    },
    changeClient() {
      this.$router.push({
        name: 'ChangeClient',
      });
    },
  },
};
</script>
